import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { routes } from 'routes'

import { ApplicationsList } from './ApplicationsList'
import { CreateApplicationWizard } from './CreateApplicationWizard'
import { ApplicationOverviewRouter } from './applicationOverview/index'
import { StatusPreview } from './components/StatusPreview'

function ApplicationsPage() {
  return (
    <Switch>
      <Route
        path={routes.client.applications.overview.entry}
        component={ApplicationOverviewRouter}
      />

      <Route
        exact
        path={routes.client.applications.list}
        component={ApplicationsList}
      />

      <Route
        exact
        path={routes.client.applications.statusPreview}
        component={StatusPreview}
      />

      <Route
        path={`${routes.client.applications.create}/:id`}
        component={CreateApplicationWizard}
      />

      <Redirect to={routes.client.applications.overview} />
    </Switch>
  )
}

export { ApplicationsPage }
